<template>
  <div v-loading="initLoading">
    <div class="LabelView">
      <div style="font-size: 20px">
        <el-breadcrumb separator="/" style="margin-left: 10px; margin-top: 5px">
          <el-breadcrumb-item :to="{ path: '/console' }">数据中心</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/LabelView' }">自定义标签设置</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-row>
        <el-col :span="24">
          <div style="font-size: 25px;margin-top: 15px;">
            <p>自定义标签设置</p>
          </div>
        </el-col>
      </el-row>
      <div style="width: 100%; font-family: 宋体; font-size: 25px;font-weight: bold">
        <el-form :model="ruleForm2" status-icon :rules="rules2" ref="ruleForm2" label-width="100px"
                 style=" margin-top: 30px">
          <el-form-item label="供应商" prop="selectedSupplierIds">
            <el-select v-model="ruleForm2.selectedSupplierIds" value-key="id" filterable multiple placeholder="请选择"
                       @change="supplierid()" style="width: 400px">
              <el-option
                v-for="(item) in user"
                :key="item.id"
                :label="item.name"
                :value='item'>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="区域" prop="selectRegionals">
            <el-select popper-class="el-select" v-model.number="ruleForm2.selectedRegionals" multiple
                       style="width: 400px" value-key="id" @change="selectRegionalss"
                       placeholder="可筛选，不筛选则导出全部"
                       :disabled="ruleForm2.selectedSupplierIds != '' && ruleForm2.selectedSupplierIds.length === 1 ?false:true">
              <select-all-option v-model="ruleForm2.selectedRegionals" group-value="regionals"
                                 @change="selectRegionalss" :data="selectRegionals"/>
              <el-option-group
                v-for="group in selectRegionals"
                :key="group.name"
                :label="group.name">
                <el-option
                  v-for="item in group.regionals"
                  :key="item.id"
                  :label="item.name"
                  :value="item">
                </el-option>
              </el-option-group>
            </el-select>
          </el-form-item>
          <el-form-item label="省份" prop="selectProvinces">
            <el-select popper-class="el-select" v-model.number="ruleForm2.selectedProvinces" style="width: 400px"
                       value-key="id" multiple placeholder="可筛选，不筛选则导出全部"
                       :disabled="ruleForm2.selectedRegionals != '' ?false:true">
              <select-all-option v-model="ruleForm2.selectedProvinces" group-value="children" :data="selectProvinces"/>
              <el-option-group
                v-for="group in selectProvinces"
                :key="group.name"
                :label="group.name">
                <el-option
                  v-for="item in group.children"
                  :key="item.id"
                  :label="item.name"
                  :value="item">
                </el-option>
              </el-option-group>
            </el-select>
          </el-form-item>

          <transition name="el-fade-in-linear">
            <el-form-item label="现有标签" v-show="ruleForm2.selectedSupplierIds.length">
              <div style="display: inline-block">
                <div v-if="tags.length">
                  <el-tag
                    class="tag"
                    v-for="item in tags"
                    :key="item"
                    type="info"
                    effect="plain">
                    {{ item }}
                  </el-tag>
                </div>
                <div v-else>
                  <el-tag
                    class="tag"
                    type="info"
                    effect="plain">
                    暂无标签
                  </el-tag>
                </div>
              </div>

              <el-button plain size="small" icon="el-icon-plus" @click="tagDialogVisible = true" v-if="tags.length < 10"
                         style="color: #ED7043; border-color: #ED7043; display: inline-block">
                添加标签
              </el-button>

            </el-form-item>
          </transition>
        </el-form>
        <el-row style="margin-left: 100px;text-align: center">
          <el-col :span="3">
            <el-button style="color: white; border-color: #FF6633; background-color: #FF6633" :loading="loading"
                       @click="importLabel">导出填写模板
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-button style="color: white; border-color: #FF6633; background-color: #FF6633" :loading="loading2"
                       @click="uploadLabel" :disabled="dashboardSales">上传标签数据
            </el-button>
            <input type="file" ref="uploadLabel" v-show="false" accept=".xls,.xlsx" @change="extraExcel"/>
            <div v-if="successMsg.length > 0"
                 style="line-height: 1.5em;font-size: 10px;padding:0;font-family: 微软雅黑;font-weight: 0;color: #909399;margin-top:10px">
              <div>上传成功</div>
              <div v-for="m in successMsg" style="text-align: center">
                {{ m.success }}人已更新[{{ m.name }}]标签
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <el-dialog
      title="添加自定义标签"
      :visible.sync="tagDialogVisible"
      :close-on-click-modal="false"
      :show-close="false"
      width="20%"
      top="40vh"
      center>
      <el-input v-model="tagName" placeholder="请输入添加标签名"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="tagDialogVisible = false">取消</el-button>
        <el-button type="primary" :disabled="tagName == ''" @click="open">新建</el-button>
     </span>
    </el-dialog>

  </div>
</template>

<script>
import {allUser} from '@/api/ReportDetailPage'
import {
  addSaleExtraProp,
  importLabel,
  putExtraExcel,
  querySaleExtraPropBySupplier
} from '@/api/ReportDetailPagePurchase'
import selectAllOption from "@/components/selectAllOption";

export default {
  components: {selectAllOption},
  data() {
    return {
      ruleForm2: {
        selectedSupplierIds: '', selectedRegionals: '', selectedProvinces: ''
      },
      // 判断供应商是否选择
      rules2: {
        selectedSupplierIds: [
          {required: true, message: '请至少选择一个供应商', trigger: 'change'}
        ]
      },
      user: [],
      value: '',
      selectRegionals: [],
      selectProvinces: [],
      token: '',
      loading: false,
      loading2: false,
      fileList: [],
      successMsg: [],
      supplierId: '',
      dashboardSales: false,
      initLoading: true,
      tags: [],
      tagDialogVisible: false,
      tagName: ''
    }
  },
  created() {
    // 进入测页面以后 查询出下拉框的所有值
    this.allUser()
    this.$store.commit('addTips', ['每次修改标签时都请重新下载模板后再填写，以避免模板数据与当前数据不符而产生差错', '允许设置的标签类型上限：10种，单次上传允许修改的标签数量：30000条'])
    this.dashboardSales = localStorage.getItem('dashboardSales') == 2;
  },
  methods: {
    uploadLabel() {
      if (this.ruleForm2.selectedSupplierIds.length < 1) {
        this.$notify({
          title: '警告',
          message: '请至少选择一个供应商',
          type: 'warning',
          position: 'bottom-right'
        })
        return
      }
      this.supplierId = this.ruleForm2.selectedSupplierIds[0].id
      this.$refs.uploadLabel.click()
    },
    extraExcel() {
      this.loading2 = true
      let inputDOM = this.$refs.uploadLabel
      let file = inputDOM.files[0]
      let formData = new FormData();
      formData.append("file", file)
      putExtraExcel(this.token, this.supplierId, formData).then(r => {
        let {data} = r
        if (data.code == 200) {
          this.successMsg = data.date
          this.$notify.success({
            title: '成功',
            message: "",
            position: 'bottom-right'
          })
        }
        if (data.code == 1)
          this.$notify.error({
            title: '错误',
            message: data.msg,
            position: 'bottom-right'
          })
      }).catch(error => {
        let status = error.response.status;
        if (status == 500) {
          this.$notify.error({
            title: '错误',
            message: '数据中心修改失败，请联系管理员',
            position: 'bottom-right'
          })
        }
      }).finally(() => {
        this.loading2 = false
        this.$refs.uploadLabel.value = ''
      })
    },
    supplierid() {
      // 根据选择的供应商赋值给品牌和区域
      // eslint-disable-next-line eqeqeq
      if (this.ruleForm2.selectedSupplierIds != '') {
        if (this.ruleForm2.selectedSupplierIds.length > 1) {
          this.ruleForm2.selectedSupplierIds.splice(1, 1)
          this.$notify({
            title: '警告',
            message: '只能选择一个供应商',
            type: 'warning',
            position: 'bottom-right'
          })
        }
        this.selectRegionals = this.ruleForm2.selectedSupplierIds

        this.querySaleExtraPropBySupplier();
      } else {
        this.ruleForm2.selectedRegionals = []
        this.ruleForm2.selectedProvinces = []
      }
    },
    selectRegionalss() {
      // 根据选择的区域赋值给不同的省份
      this.selectProvinces = this.ruleForm2.selectedRegionals
    },
    allUser() {
      this.token = localStorage.getItem('token')
      allUser(this.token, null).then(res => {
        if (res.data.suppliers != null) {
          this.user = res.data.suppliers
          if (this.user.length == 1) {
            this.ruleForm2.selectedSupplierIds = this.user;
            this.supplierid();
          }
        }
        this.initLoading = false
      }).catch(error => {
        let status = error.response.status;
        if (status == 500) {
          this.$notify.error({
            title: '错误',
            message: '查询失败，请联系管理员',
            position: 'bottom-right'
          })
        }
      })
    },
    importLabel() {
      // eslint-disable-next-line eqeqeq
      if (this.ruleForm2.selectedSupplierIds != '') {
        this.token = localStorage.getItem('token')
        // eslint-disable-next-line eqeqeq
        if (this.ruleForm2.selectedBrands == '') {
          this.ruleForm2.selectedBrands = this.ruleForm2.selectedParentBrands
        }
        this.loading = true
        importLabel(this.token, this.ruleForm2).then(res => {
          if (res !== null) {
            this.$notify({
              type: 'success',
              message: '导出成功',
              title: '成功',
              position: 'bottom-right'
            })
            this.handleDownload(res)
            this.loading = false
          }
        }).catch(error => {
          let status = error.response.status;
          if (status == 500) {
            this.$notify({
              title: '错误',
              message: '导出错误，请及时联系管理员',
              type: 'error',
              position: 'bottom-right'
            })
          }
        }).finally(() => {
          this.loading = false
        })
      } else {
        this.$notify({
          title: '警告',
          message: '请至少选择一个供应商',
          type: 'warning',
          position: 'bottom-right'
        })
      }
    },
    handleDownload(res) {
      // 创建下载的链接
      // 设置该文件的mime类型，这里对应的mime类型对应为.xlsx格式
      let blob = new Blob([res.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      const fileName = decodeURI(res.headers['filename'])
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
    },
    querySaleExtraPropBySupplier() {
      querySaleExtraPropBySupplier(this.token, this.ruleForm2.selectedSupplierIds[0].id).then(res => {
        if (res.data.code == 200) {
          this.tags = res.data.data;
        }
      })
    },
    addSaleExtraProp() {
      if (this.tags.length >= 10) {
        return this.$message({
          type: 'error',
          message: '最多只能添加十个标签'
        })
      }

      var param = {
        sup: this.ruleForm2.selectedSupplierIds[0].id,
        name: this.tagName
      }
      addSaleExtraProp(this.token, param).then(res => {
        if (res.data.code == 200) {
          this.tags.push(this.tagName);
          this.tagName = '';
          this.tagDialogVisible = false;
          this.$message({
            type: 'success',
            message: '添加成功!'
          });
        }
      })
    },
    open() {
      this.$confirm('新建的自定义标签无法修改或删除,是否确认添加?', {
        confirmButtonText: '确定添加',
        cancelButtonText: '取消添加',
        type: 'warning'
      }).then(() => {
        this.addSaleExtraProp();
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消添加'
        });
      });
    }
  }
}
</script>

<style scoped>

.LabelView {
  padding: 20px;
  background-color: #fafafa;
}

.el-select .el-select-dropdown__list {
  list-style: none;
  padding: 0px 0;
  margin: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.tag {
  margin-right: 10px;
}

>>> .el-dialog__title {
  color: #ED7043;
  font-weight: 600;
}

</style>
